import { render, staticRenderFns } from "./MDPropertyGrid.vue?vue&type=template&id=c302a792&scoped=true&"
import script from "./MDPropertyGrid.vue?vue&type=script&lang=ts&"
export * from "./MDPropertyGrid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17.15_vue-template-compiler@2.6.11_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c302a792",
  null
  
)

export default component.exports